
// Logging helpers — controlled by enableLog option
const log = true ? (...args) => console.log('[astro-mermaid]', ...args) : () => {};
const logError = (...args) => console.error('[astro-mermaid]', ...args);

// Check if page has mermaid diagrams
const hasMermaidDiagrams = () => {
  return document.querySelectorAll('pre.mermaid').length > 0;
};

// Shared mermaid initialization function
let mermaidPromise = null;
let mermaidInstance = null;

async function loadMermaid() {
  if (mermaidPromise) return mermaidPromise;

  log('Loading mermaid.js...');

  mermaidPromise = import('mermaid').then(async ({ default: mermaid }) => {
    // Register icon packs if provided — uses safe fetch(url) instead of eval
    const iconPacks = [];
    if (iconPacks && iconPacks.length > 0) {
      log('Registering', iconPacks.length, 'icon packs');
      const packs = iconPacks.map(pack => {
        if (pack.icons) {
          // Inline icon data — register directly, no fetch needed
          return { name: pack.name, icons: pack.icons };
        }
        return {
          name: pack.name,
          loader: () => fetch(pack.url).then(res => res.json())
        };
      });
      await mermaid.registerIconPacks(packs);
    }

    // Register ELK layouts if the optional peer is available at build-time
    

    mermaidInstance = mermaid;
    return mermaid;
  }).catch(error => {
    logError('Failed to load mermaid:', error);
    mermaidPromise = null;
    throw error;
  });

  return mermaidPromise;
}

// Mermaid configuration
const defaultConfig = {"startOnLoad":false,"theme":"default"};

// Theme mapping for auto-theme switching
const themeMap = {
  'light': 'default',
  'dark': 'dark'
};

// Initialize all mermaid diagrams
async function initMermaid() {
  log('Initializing mermaid diagrams...');
  const diagrams = document.querySelectorAll('pre.mermaid');

  log('Found', diagrams.length, 'mermaid diagrams');

  if (diagrams.length === 0) {
    return;
  }

  // Load mermaid if not already loaded
  const mermaid = await loadMermaid();

  // Get current theme from multiple sources
  let currentTheme = defaultConfig.theme;

  if (true) {
    // Check both html and body for data-theme attribute
    const htmlTheme = document.documentElement.getAttribute('data-theme');
    const bodyTheme = document.body.getAttribute('data-theme');
    const dataTheme = htmlTheme || bodyTheme;
    currentTheme = themeMap[dataTheme] || defaultConfig.theme;
    log('Using theme:', currentTheme, 'from', htmlTheme ? 'html' : 'body');
  }

  // Configure mermaid with gitGraph support
  mermaid.initialize({
    ...defaultConfig,
    theme: currentTheme,
    gitGraph: {
      mainBranchName: 'main',
      showCommitLabel: true,
      showBranches: true,
      rotateCommitLabel: true
    }
  });

  // Render each diagram
  for (const diagram of diagrams) {
    // Skip if already processed
    if (diagram.hasAttribute('data-processed')) continue;

    // Store original content
    if (!diagram.hasAttribute('data-diagram')) {
      diagram.setAttribute('data-diagram', diagram.textContent || '');
    }

    const diagramDefinition = diagram.getAttribute('data-diagram') || '';
    const id = 'mermaid-' + Math.random().toString(36).slice(2, 11);

    log('Rendering diagram:', id);

    try {
      // Clear any existing error state
      const existingGraph = document.getElementById(id);
      if (existingGraph) {
        existingGraph.remove();
      }

      const { svg } = await mermaid.render(id, diagramDefinition);
      diagram.innerHTML = svg;
      diagram.setAttribute('data-processed', 'true');
      log('Successfully rendered diagram:', id);
    } catch (error) {
      logError('Mermaid rendering error for diagram:', id, error);
      // Build error UI safely — use textContent to prevent XSS via error messages
      const errorDiv = document.createElement('div');
      errorDiv.style.cssText = 'color: red; padding: 1rem; border: 1px solid red; border-radius: 0.5rem;';
      const strong = document.createElement('strong');
      strong.textContent = 'Error rendering diagram:';
      const msg = document.createElement('span');
      msg.textContent = ' ' + (error.message || 'Unknown error');
      errorDiv.appendChild(strong);
      errorDiv.appendChild(msg);
      diagram.textContent = '';
      diagram.appendChild(errorDiv);
      diagram.setAttribute('data-processed', 'true');
    }
  }
}

// Initialize on first load if there are diagrams
if (hasMermaidDiagrams()) {
  log('Mermaid diagrams detected on initial load');
  initMermaid();
} else {
  log('No mermaid diagrams found on initial load');
}

// Re-render on theme change if auto-theme is enabled
if (true) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
        // Reset processed state and re-render
        document.querySelectorAll('pre.mermaid[data-processed]').forEach(diagram => {
          diagram.removeAttribute('data-processed');
        });
        initMermaid();
      }
    }
  });

  // Observe both html and body for data-theme changes
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme']
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-theme']
  });
}

// Handle view transitions (for Astro View Transitions API)
// This is registered ALWAYS, not just when initial page has diagrams
document.addEventListener('astro:after-swap', () => {
  log('View transition detected');
  // Check if new page has diagrams
  if (hasMermaidDiagrams()) {
    initMermaid();
  }
});


          // Add CSS for mermaid diagrams
          const style = document.createElement('style');
          style.textContent = `
            /* Prevent layout shifts by setting minimum height */
            pre.mermaid {
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 2rem 0;
              padding: 1rem;
              background-color: transparent;
              border: none;
              overflow: auto;
              min-height: 200px; /* Prevent layout shift */
              position: relative;
            }
            
            /* Loading state with skeleton loader */
            pre.mermaid:not([data-processed]) {
              background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite;
            }
            
            /* Dark mode skeleton loader */
            [data-theme="dark"] pre.mermaid:not([data-processed]) {
              background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
              background-size: 200% 100%;
            }
            
            @keyframes shimmer {
              0% {
                background-position: -200% 0;
              }
              100% {
                background-position: 200% 0;
              }
            }
            
            /* Show processed diagrams with smooth transition */
            pre.mermaid[data-processed] {
              animation: none;
              background: transparent;
              min-height: auto; /* Allow natural height after render */
            }
            
            /* Ensure responsive sizing for mermaid SVGs */
            pre.mermaid svg {
              max-width: 100%;
              height: auto;
            }
            
            /* Optional: Add subtle background for better visibility */
            @media (prefers-color-scheme: dark) {
              pre.mermaid[data-processed] {
                background-color: rgba(255, 255, 255, 0.02);
                border-radius: 0.5rem;
              }
            }
            
            @media (prefers-color-scheme: light) {
              pre.mermaid[data-processed] {
                background-color: rgba(0, 0, 0, 0.02);
                border-radius: 0.5rem;
              }
            }
            
            /* Respect user's color scheme preference */
            [data-theme="dark"] pre.mermaid[data-processed] {
              background-color: rgba(255, 255, 255, 0.02);
              border-radius: 0.5rem;
            }
            
            [data-theme="light"] pre.mermaid[data-processed] {
              background-color: rgba(0, 0, 0, 0.02);
              border-radius: 0.5rem;
            }
          `;
          document.head.appendChild(style);
        
import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});